import { render, staticRenderFns } from "./CustomerCorporateEmployeesLink.vue?vue&type=template&id=1a35a878&scoped=true"
import script from "./CustomerCorporateEmployeesLink.vue?vue&type=script&lang=js"
export * from "./CustomerCorporateEmployeesLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a35a878",
  null
  
)

export default component.exports